export const PUBLIC_FILE = /\.(.*)$/;

export const ALLOWED_LOCALE = ['nl', 'fr'];

export const MY_ENECO_SUB_PATH = 'my-eneco';

export const HAS_SEEN_PRIVACY_COOKIE = 'HAS_SEEN_PRIVACY';

/** Set when merge check returns Merged or NotPossible — skip repeat checks */
export const PROFILE_MERGE_CHECK_DONE_COOKIE = 'PROFILE_MERGE_CHECK_DONE';

/** Set after first ProfileMergeCheck (BE sends email in that call). Value = sessionId. Skips repeat Check. */
export const PROFILE_MERGE_RESOLVED_COOKIE = 'PROFILE_MERGE_RESOLVED';

/** Email-validation landing (should be set to this in Sitecore) */
export const PROFILE_MERGE_EMAIL_SENT_PATH = '/my-eneco/account-merge-email';

const PROFILE_MERGE_COOKIE_MAX_AGE_S = 60 * 60; // 1 hour

export const profileMergePersistentCookieOptions = {
  path: '/' as const,
  maxAge: PROFILE_MERGE_COOKIE_MAX_AGE_S,
  sameSite: 'lax' as const,
};
